// import {
//   createProductReview,
//   createQuestion,

// } from "@/requests/product";
import { blogsCommentsSubmit, createQuestion } from "@/requests/product";
import { setGlobalPopupElement } from "@/store/features/globalSlice";
import { useAppDispatch, useAppSelector } from "@/store/hooks";
import { toastMe } from "@/utils";

import { useState } from "react";

interface Props {
  blogs: any;
}

const AskCommentForm = ({ blogs }: Props) => {
  const [comment, setComment] = useState("");
  const [loading, setLoading] = useState(false);
  const dispatch = useAppDispatch();
  const user = useAppSelector((state) => state.auth.user);
  const [name, setName] = useState<string>("");

  const handleSubmit = () => {
    if (!!!user?.firstName && name === "") {
      toastMe("Please enter your name!", "warning");
      return;
    }

    setLoading(true);

    const commentData: any = {};

    commentData.blog_id = blogs.id;
    commentData.email = user?.email;
    commentData.content = comment;
    commentData.first_name = name;

    blogsCommentsSubmit(commentData)
      .then((response) => {
        // dispatch(setIsUserReviewed({ [product.id]: true }));

        if (response?.Success) {
          toastMe(
            "Successfully published your question, Please wait for answer",
            "success"
          );
        } else {
          toastMe(response.Message || "Something went wrong!", "error");
        }
      })
      .catch((error) => {
        toastMe(error.Message || "Something went wrong!", "error");
      })
      .finally(() => {
        setLoading(false);
        dispatch(setGlobalPopupElement(null));
      });
  };

  return (
    <div className="bg-white p-8 rounded-md md:min-w-[30vw] md:max-w-[80vw] max-h-[80vh] overflow-y-scroll scrollbar-ui">
      <div className="overflow-hidden">
        <div className="mb-4 flex gap-2 items-start">
          <div>
            <p className="font-semibold text-primary ">Comment </p>

            {/* <p>{product.name}</p> */}
          </div>
        </div>

        <div className="border-t border-gray-300 pt-4">
          <div className="mb-4">
            <p className="font-semibold">Blog</p>
            <p>{blogs?.title}</p>
          </div>
          {!!!user?.firstName && (
            <div className="flex flex-col">
              <label htmlFor="name" className="text-lg font-semibold">
                Name
              </label>
              <input
                className="w-full bg-backgournd-card rounded-[5px] py-3 px-4 text-sm text-gray3"
                id="name"
                type="text"
                placeholder="Your Name"
                required
                value={name}
                onChange={(e) => setName(e.target.value)}
              />
            </div>
          )}
          <div>
            <label htmlFor="images" className="font-semibold">
              Comment
            </label>{" "}
            <br />
            <textarea
              name="review"
              id="review"
              cols={10}
              rows={5}
              className="border rounded w-full p-2 my-2"
              onChange={(e) => setComment(e.target.value)}
              required
            ></textarea>
          </div>
          <button
            className="bg-primary text-white px-4 py-2 rounded-md font-medium disabled:opacity-40 flex items-center gap-2"
            onClick={handleSubmit}
            disabled={loading}
          >
            SUBMIT
            {loading && (
              <span className="block border-gray-300 h-5 w-5 animate-spin rounded-full border-2 border-t-blue-600" />
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

export default AskCommentForm;
